import CommonPopup from 'components/ui-kit/CommonPopup/index'
import { useState } from 'react'
import SeedsTab from './components/SeedsTab/index'
import VerifyTab from './components/VerifyTab/index'
import './FairnessModal.scss'
import { DEFAULT_GAME_ID } from 'constants/index'
import { copyToClipboard } from 'helpers/common.helpers'
import { openErrorToaster, openSuccessToaster } from 'helpers/toaster.helpers'
import { debounce } from 'lodash'
import { useTranslation } from 'react-i18next'


const OneToOneGameFairnessModal = ({
  handleModal,
  open,
  gameId,
  resultData,
  roundBetHistory
}) => {
  if (!open) {
    return <></>
  }
  const [hashCode, setHashCode] = useState(roundBetHistory ? roundBetHistory?.hashCode : '')
  const [clientSeed, setClientSeed] = useState(roundBetHistory ? roundBetHistory?.clientSeed : '')
  const [serverSeed, setServerSeed] = useState(roundBetHistory ? roundBetHistory?.serverSeed : '')
  const [activeTab, setActiveTab] = useState(roundBetHistory ? 2 : 1)

  const handleActiveTab = (tabNumber) => {
    setActiveTab(tabNumber)
  }
  const {t} = useTranslation();
  const handleCopyCode = debounce((value) => {
    const isCopySuccessful = copyToClipboard(value)
    openSuccessToaster({ message: 'Copied' })
    if (!isCopySuccessful) {
      return openErrorToaster({ message: 'copyNotSupported' })
    }
    return null
  }, 300)

  return (
    <CommonPopup
      modalCloseHandler={handleModal}
      id='mines-fairness-popup'
    >
      <div className='heading-wrap'>
        <h5 className='modal-title text-white'>{t('provablyFair')}</h5>
      </div>
      <div className='body-wrap provably-fair-body'>
        <form>
          <ul className='nav nav-pills my-3' id='myTab' role='tablist'>
            <li className='nav-item' role='presentation'>
              <button
                onClick={() => handleActiveTab(1)}
                className={`border-0 nav-link ${activeTab === 1 ? 'active' : ''}`}
                type='button'
              >
                {t('SEEDS')}
              </button>
            </li>
            <li className='nav-item' role='presentation'>
              <button
                onClick={() => handleActiveTab(2)}
                className={`border-0 nav-link ${activeTab === 2 ? 'active' : ''}`}
                type='button'
              >
                {t('VERIFY')}
              </button>
            </li>
          </ul>
          {activeTab === 1
            ? (
              <SeedsTab
                gameId={gameId}
                handleCopyCode={handleCopyCode}
                resultData={resultData}
              />)
            : (
              <VerifyTab
                handleCopyCode={handleCopyCode}
                gameId={gameId}
                clientSeed={clientSeed}
                setClientSeed={setClientSeed}
                serverSeed={serverSeed}
                setServerSeed={setServerSeed}
                resultData={resultData}
                roundBetHistory={roundBetHistory}
                hashCode={hashCode}
                setHashCode={setHashCode}
              />
              )}
        </form>
      </div>
    </CommonPopup>
  )
}

export default OneToOneGameFairnessModal
